<template>
  <div
    class="video-script-peeker"
    :class="{
      'video-script-peeker--hidden': !videoScriptPeekerVisible,
      'video-script-peeker--expanded': activeVideoScript
    }"
  >
    <div class="video-script-peeker__header">
      <h4 class="video-script-peeker__title">视频脚本</h4>
      <div
        class="iconfont video-script-peeker__close icon-close"
        @click="closePeeker"
      ></div>
    </div>
    <a-spin class="video-script-peeker__body" :spinning="loading">
      <template v-if="activeVideoScript">
        <h3 class="video-script-peeker__name">
          {{ activeVideoScript.name }}
        </h3>
        <a-table
          :dataSource="activeVideoScript.paging"
          :rowKey="id"
          :columns="columns"
          :pagination="false"
          :scroll="{ x: 1410, y: 320 }"
          class="video-script-peeker__table"
        >
          <template #default="val">
            <template v-if="val">{{ val }}</template>
            <template v-else>&minus;</template>
          </template>

          <template #frag="_, _rec, index">{{ index + 1 }}</template>
          <template #duration="val">{{ +val | displayDuration }}</template>
          <template #img="val">
            <div
              class="video-script-menu__thumb video-script-menu__thumb--hoverable"
              :style="{
                backgroundImage: `url(${val})`
              }"
              v-if="val"
              @click="previewImage([val])"
            />
            <p v-else>&minus;</p>
          </template>
        </a-table>
      </template>
      <template v-else>
        <p>当前未使用视频脚本。</p>
        <a-button type="primary" @click="gotoVideoScripts">
          了解视频脚本
        </a-button>
      </template>
    </a-spin>
  </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex';
import { get } from '../../utils/api';
export default {
  data() {
    return {
      activeVideoScript: null,
      loading: false,
      columns: [
        {
          title: '片段',
          scopedSlots: {
            customRender: 'frag'
          },
          key: 'frag',
          width: 60,
          fixed: 'left'
        },
        // {
        //   title: '视频框架',
        //   dataIndex: 'frame',
        //   width:80,
        //   scopedSlots: {
        //     customRender: 'default'
        //   }
        // },
        {
          title: '解说/对白',
          dataIndex: 'commentary',
          width: 240,
          scopedSlots: {
            customRender: 'default'
          }
        },
        {
          title: '景别',
          dataIndex: 'scene',
          width: 120,
          scopedSlots: {
            customRender: 'default'
          }
        },
        {
          title: '时长',
          dataIndex: 'duration',
          scopedSlots: {
            customRender: 'duration'
          },
          width: 80
        },
        {
          title: '字幕',
          dataIndex: 'tts',
          width: 180,
          scopedSlots: {
            customRender: 'default'
          }
        },
        {
          title: '内容',
          dataIndex: 'content',
          scopedSlots: {
            customRender: 'default'
          }
        },
        {
          title: '画面描述',
          dataIndex: 'desc',
          width: 180,
          scopedSlots: {
            customRender: 'default'
          }
        },
        {
          title: '画面参考',
          dataIndex: 'img',
          scopedSlots: {
            customRender: 'img'
          },
          width: 168
        },
        {
          title: '备注',
          dataIndex: 'remarks',
          width: 160,
          scopedSlots: {
            customRender: 'default'
          }
        }
      ]
    };
  },
  computed: {
    ...mapState(['usedVideoScriptId', 'videoScriptPeekerVisible', 'currentIcon'])
  },
  methods: {
    ...mapMutations(['handleVideoScriptPeekerVisible', 'handleCurrentIcon']),
    getVideoScript() {
      const val = this.usedVideoScriptId;
      if (val) {
        this.loading = true;
        get('script/info', { id: val }).then(resp => {
          this.activeVideoScript = resp;
          this.loading = false;
        });
      } else {
        this.activeVideoScript = null;
        this.templateList = [];
      }
    },
    closePeeker() {
      this.handleVideoScriptPeekerVisible(false);
    },
    gotoVideoScripts() {
      this.handleCurrentIcon('videoscript');
    },
    previewImage(list) {
      this.$store.commit('handleVideoScriptPreviewerVisible', true);
      this.$store.commit('handleVideoScriptPreviewerList', list);
    }
  },
  mounted() {
    this.getVideoScript();
  },
  watch: {
    usedVideoScriptId() {
      this.getVideoScript();
    },
    currentIcon(val) {
      if ({
        videoscript: 1,
        subtitle: 1
      }[val]) {
        this.handleVideoScriptPeekerVisible(false);
      }
    }
  },
  filters: {
    displayDuration(duration) {
      const minutes = Math.floor(duration / 60);
      let seconds = Math.floor(duration % 60);
      seconds = (seconds < 10 ? '0' : '') + seconds;

      return [minutes, seconds].join(':');
    }
  }
}
</script>
<style>
.video-script-peeker {
  position: absolute;
  background: #fff;
  right: 296px;
  top: 80px;
  z-index: 99;
  transition: 0.3s;
  width: 450px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.06), 0 0 8px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  max-height: calc(100% - 80px);
}

.video-script-peeker--expanded {
  width: 1450px;
  max-width: calc(100% - 660px);
  min-width: 600px;
}

.video-script-peeker__header {
  height: 44px;
  background: rgba(0, 0, 0, 0.03);
  box-shadow: inset 0 -1px rgba(0, 0, 0, 0.06);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.video-script-peeker__title {
  font-size: 14px;
  font-weight: 400;
  margin: 0 20px;
}

.video-script-peeker__close {
  font-size: 20px;
  cursor: pointer;
  color: #656667;
  padding: 8px 12px;
}

.video-script-peeker__close:hover,
.video-script-peeker__close:focus {
  color: #e57;
}

.video-script-peeker__body {
  flex-grow: 1;
  overflow: auto;
  padding: 16px 20px;
}

.video-script-peeker--hidden {
  visibility: hidden;
  opacity: 0;
  transform: translateY(-100%);
}

.video-script-peeker__name {
  font-size: 18px;
}

.video-script-peeker__table th {
  white-space: nowrap;
}

.video-script-peeker__table tr > td,
.video-script-peeker__table tr > th {
  padding: 12px 14px;
}

.video-script-menu__thumb {
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  z-index: 0;
}

.video-script-menu__thumb:before {
  content: "";
  display: block;
  padding-bottom: 56%;
  transition: 0.3s;
}

.video-script-menu__thumb--hoverable {
  width: 140px;
  cursor: pointer;
}

.video-script-menu__thumb--hoverable:hover:before {
  box-shadow: inset 0 0 0 2px #1890ff;
}

.video-script-detail-image-count {
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  border-radius: 2px;
  padding: 3px 8px;
  position: absolute;
  right: 6px;
  bottom: 6px;
  font-size: 12px;
  line-height: 1.5;
}
</style>